import { toClassName } from './shared_functions'
import { objectStyleByLegend, WBS_COLORS } from '../helpers/colors'

const ObjectColorLegend = ({ legend, objects, draggable = false }) => {
  if (objects) {
    const objectsByUserColorId = {}

    if (legend === 'user_color') {
      objects
        .filter((o) => o.user_color.id)
        .forEach((o) => {
          objectsByUserColorId[o.user_color.id] = o
        })

      return (
        <>
          {Object.values(objectsByUserColorId).map((o) => (
            <div
              className="legend-element user_color"
              draggable={draggable}
              key={o.user_color.id}
              data-value={o.user_color.id}
            >
              <span className="priority-label" style={objectStyleByLegend(o, 'user_color')}>
                <img src={o.user_color.avatar_url} className="react-select-avatar" />
                {o.user_color.name}
              </span>
            </div>
          ))}
        </>
      )
    }

    if (legend === 'project_color') {
      objects
        .filter((o) => o.project_color.id)
        .forEach((o) => {
          objectsByUserColorId[o.project_color.id] = o
        })

      return (
        <>
          {Object.values(objectsByUserColorId).map((o) => (
            <div
              className="legend-element"
              draggable={draggable}
              key={o.project_color.id}
              data-value={o.project_color.id}
            >
              <span className="priority-label" style={objectStyleByLegend(o, 'project_color')}>
                {o.project_color.name}
              </span>
            </div>
          ))}
        </>
      )
    }

    if (legend === 'company_color') {
      objects
        .filter((o) => o.company_color.id)
        .forEach((o) => {
          objectsByUserColorId[o.company_color.id] = o
        })

      return (
        <>
          {Object.values(objectsByUserColorId).map((o) => (
            <div
              className="legend-element"
              draggable={draggable}
              key={o.company_color.id}
              data-value={o.company_color.id}
            >
              <span className="priority-label" style={objectStyleByLegend(o, 'company_color')}>
                {o.company_color.name}
              </span>
            </div>
          ))}
        </>
      )
    }
  }

  return (
    <>
      {['target_user_id', 'user_ids'].includes(legend) && (
        <>
          {window.appData.users.map((user) => (
            <div className="legend-element" draggable={draggable} key={user.id} data-value={user.id}>
              <span>
                <img src={user.avatar_url} alt={user.name} className="react-select-avatar" />
                {user.name}
              </span>
            </div>
          ))}
        </>
      )}
      {legend == 'progress' && (
        <>
          {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((progress) => (
            <div className="legend-element" draggable={draggable} key={progress} data-value={progress}>
              <span
                className="priority-label"
                style={{
                  ...objectStyleByLegend({ progress }, 'progress'),
                  minWidth: '60px'
                }}
              >
                {progress}%
              </span>
            </div>
          ))}
        </>
      )}

      {['task_type_id', 'task_status_id', 'project_status_id', 'project_type_id', 'task_priority_id', 'project_priority_id', 'company_type_id', 'company_phase_id', 'company_status_id'].includes(legend) && (
        <>
          {window.appData.elements[toClassName(legend)].map((element) => (
            <div className="legend-element" draggable={draggable} key={element.id} data-value={element.id}>
              <span className="priority-label" style={objectStyleByLegend({ [legend]: element.id }, legend)}>
                {element.name}
              </span>
            </div>
          ))}
        </>
      )}

      {legend == 'wbs_color' && (
        <>
          {WBS_COLORS.map((c) => (
            <div className="legend-element" draggable={draggable} key={c} data-value={c}>
              <span className="priority-label" style={{ backgroundColor: c }}>
                &nbsp;
              </span>
            </div>
          ))}
        </>
      )}
    </>
  )
}

export default ObjectColorLegend
